import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';
import ImgResponsive from './ImgResponsive';

const ads1 = "/images/SQ_ws/SQ_ws-1.jpg";
const ads2 = "/images/SQ_ws/SQ_ws-2.jpg";
const ads3 = "/images/SQ_ws/SQ_ws-3.jpg";

const CarouselWs: React.FC = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <Box sx={{ width: '100%', margin: '0 auto', padding: '0px 0px 0px 0px' }}>
      <Slider {...settings}>
        <div>
          <ImgResponsive src={ads1} alt="Slide 1" />
        </div>
        <div>
          <ImgResponsive src={ads2} alt="Slide 2" />
        </div>
        <div>
          <ImgResponsive src={ads3} alt="Slide 3" />
        </div>
      </Slider>
    </Box>
  );
};

export default CarouselWs;
